import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import { Row } from "react-data-grid";
import "react-splitter-layout/lib/index";
import "./custom/splitter.css";

import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import { DialogInformation } from "../lib/components/dialoginformation";
import Confirmation from "../lib/components/confirmation";

import { SnackContext } from "../lib/context/SnackContext";

import LoadoutTableGridUnstyled from "./loadouttablegrid";
import LoadoutTableSelectedGridUnstlyed from "./loadouttableselectedgrid";
import SailingScheduleGridUnstyled from "./sailingschedulegrid";

import { SailingScheduleColumns } from "./sailingloadouttablesetup";
import CustomAutoCompleteFilter from "../lib/components/customdatagridfilter/CustomFilter";
import { FilterState, VisibleColumns } from "./components/FilterButtons";

import { handleExportShipmentsData } from "../lib/api/loadout";
import { coldroomsAllSortedMappedforCombo } from "../lib/api/coldroom";
import { PortReadyForComboIdValue, getPortReadyForComboIdValue } from "../lib/api/port";
import { getShippingLineReadyForComboIdValue } from "../lib/api/shippingline";
import { getVesselReadyForComboIdValue } from "../lib/api/vessel";

import LoadoutTableActionDialog from "./loadouttableActionDialog";

import Splitter from "m-react-splitters";
import "m-react-splitters/lib/splitters.css";
import classNames from "classnames";
import { getClientBillTypesReadyForCombo } from "../lib/api/clientbilltypes";
import { getSaleDetailByReference, sale, updateSaleJoinedRecord } from "../lib/api/sale";

import { GenerateErrorMessage } from "../lib/helpers/string_methods";
import { ClientSelector } from "./clientselector";
import { getClientsAllSortedMappedforComboCode } from "../lib/api/clients";
import { getTemperatureReadyForCombo } from "../lib/api/temperaturecodes";
import { CircularProgress } from "@material-ui/core";
import UploadDialog from "./components/UploadDialog";
import { getSailingScheduleData } from "../lib/api/sailingschedule";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      width: "100%",
    },
    blackRow: {
      color: "black",
    },
    redRow: {
      color: "red",
    },
    boldRow: {
      fontWeight: "bold",
    },
    toolbar: {
      zIndex: 999,
      position: "absolute",
      float: "left",
      left: "5px",
    },
    tabpanel: {
      height: "100%",
      position: "relative",
      "& > :first-child": {
        height: "100%",
        padding: "0",
        "& > :first-child": {
          height: "100%",
        },
      },
    },
  });

const groupBy = (data: any[], key: string, valueKey: string) => {
  return data.reduce((obj, row) => {
    obj[row[key]] = row[valueKey];
    return obj;
  }, {});
};

type StockAllocationTableProps = {
  data: {}[];
  onReload: any;
  handleAttachment: (id) => void;
} & WithStyles<typeof styles>;

class StockAllocationTableUnstyled extends React.Component<StockAllocationTableProps, {}> {
  state = {
    data: [],
    dataChanged: false,
    loading: false,
    loadingSelected: false,
    onReload: undefined,
    selectedRows: [],
    selectedLoadout: [],
    clearedPhrase: false,
    dialoginformation: undefined,
    minGridHeight: 0,
    minGridHeightSecond: 0,
    selectedRecord: undefined,
    handleAttachment: undefined,
    coldstoreoptions: undefined,
    portoptions: undefined,
    portoptionslocal: undefined,
    shippinglines: undefined,
    vesseloptions: undefined,
    billtypesData: [],
    clientDialog: false,
    clientDialogLoading: false,
    clientsoptions: [],
    groupedPortOptions: {},
    groupedClientOptions: {},
    tempcodes: [],
    submitting: false,
    tabValue: 0,
    uploadDialogOpen: false,
    sailingScheduleData: [],
    sailingScheduleHeaders: {} as Record<string, string>,
    sailingScheduleLoading: false,
    sailingScheduleFilters: {
      market: [],
      portOfLoading: [],
      portOfDischarge: [],
    } as FilterState,
    sailingScheduleIsProcessed: false,
    sailingScheduleVisibleColumns: null as VisibleColumns | null,
    sailingScheduleGridHeight: 700,
    optionsLoaded: false,
  };

  constructor(props) {
    super(props);
    this.state.data = props.data;
    this.state.onReload = props.onReload;
    this.state.handleAttachment = props.handleAttachment;
  }

  static contextType = SnackContext;
  context!: React.ContextType<typeof SnackContext>;

  loadData = async () => {
    const [billtypesData, coldstoreoptions, portoptions, portoptionslocal, shippinglines, vesseloptions, clientsoptions, tempcodes] = await Promise.all([
      getClientBillTypesReadyForCombo(),
      coldroomsAllSortedMappedforCombo(),
      getPortReadyForComboIdValue(),
      getPortReadyForComboIdValue("ZA"),
      getShippingLineReadyForComboIdValue(),
      getVesselReadyForComboIdValue(),
      getClientsAllSortedMappedforComboCode(),
      getTemperatureReadyForCombo(),
    ]);
    const groupedPortOptions = groupBy(portoptions, "code", "description");
    const groupedClientOptions = groupBy(clientsoptions, "value", "display");
    this.setState({
      billtypesData,
      coldstoreoptions,
      portoptions,
      portoptionslocal,
      shippinglines,
      vesseloptions,
      clientsoptions,
      groupedPortOptions,
      groupedClientOptions,
      tempcodes,
      optionsLoaded: true,
    }, () => {
      this.setGridHeights();
    });
  };

  GridColumnsSailingSchedule = (data, filters, arrangement, columnsWidth) => {
    if (!data || data.length === 0) {
      return SailingScheduleColumns(
        data,
        filters,
        arrangement,
        columnsWidth,
        this.state.vesseloptions || [],
        this.state.portoptions || [],
        this.state.shippinglines || [],
        []
      );
    }

    const headers = this.state.sailingScheduleHeaders || {};
    const visibleColumns = this.state.sailingScheduleVisibleColumns;
    const isProcessed = this.state.sailingScheduleIsProcessed;
    const dischargeColumns = [];

    const headerKeys = Object.keys(headers).filter(key => key.startsWith('port_'));

    for (const colKey of headerKeys) {
      const displayName = headers[colKey];

      if (!displayName || displayName.trim() === '') continue;

      if (isProcessed && visibleColumns) {
        if (!visibleColumns.visiblePortColumns.includes(displayName.trim())) {
          continue;
        }
      }

      dischargeColumns.push({
        key: colKey,
        name: displayName.trim(),
        width: 120,
        filterable: true,
        resizable: true,
        formatter: ({ row }) => {
          let value = row[colKey];
          if (value && typeof value === 'object' && value.richText) {
            value = value.richText[0].text || '';
          }
          return <span>{value || ''}</span>;
        },
        filterRenderer: (e) => {
          return <CustomAutoCompleteFilter
            {...e}
            multiSelection={true}
            currentFilters={filters}
            fieldname={colKey}
            data={data}
            section="sailingschedule"
          />;
        },
      });
    }
    return SailingScheduleColumns(
      data,
      filters,
      arrangement,
      columnsWidth,
      this.state.vesseloptions || [],
      this.state.portoptions || [],
      this.state.shippinglines || [],
      dischargeColumns
    );
  };

  componentDidMount() {
    this.loadData();
    // this.setGridHeights();
    this.handleSailingScheduleRefresh();
  }

  handleAvailableLoadoutDoubleClick = async (row) => {
    this.setState({ loadingSelected: true });
    const data = await getSaleDetailByReference(row.loadout_reference);
    this.setState({ selectedLoadout: [{ ...row }], selectedRows: [...data], loadingSelected: false });
  };

  handleSelectedStockDoubleClick = (row: any) => {
    this.setState({ selectedRecord: row });
  };

  handleSelectedRecordClose = async () => {
    const promiseArr = [];

    this.state.selectedLoadout.map((lo) => {
      promiseArr.push(
        new Promise((resolve, reject) => {
          getSaleDetailByReference(lo.loadout_reference).then((data) => {
            resolve(data);
          });
        }),
      );
    });

    const selectedRows = [];
    Promise.all(promiseArr).then((result) => {
      result.map((resultItem) => {
        selectedRows.push(...resultItem);
      });
      this.setState({ selectedRows }, () => { });
    });
    this.setState({ selectedRecord: undefined }); //, unallocateConfirm: undefined
  };

  selectedClear = () => {
    this.setState({ selectedRows: [], selectedLoadout: [] });
  };

  setGridHeights = () => {
    const primarysplit = document.getElementsByClassName("splitter horizontal");
    this.setState({
      minGridHeight: primarysplit[0].children[0].clientHeight - 110, minGridHeightSecond: primarysplit[0].children[2].clientHeight - 80
    })
  };

  handleInfoClose = () => {
    this.setState({ dialoginformation: undefined });
  };

  handleChange = (property: string, value: any[]) => {
    const dirtyRows = [];
    const { data: oldData } = this.state;

    const updatedData = value.map((row) => {
      if (row.rowDirty === 1) {
        dirtyRows.push(row);

        const originalRow = oldData.find(oldRow => oldRow.loadout_id === row.loadout_id);

        if (!originalRow) return row;

        const newRow = { ...row };

        const invoiceChanged = originalRow.sale_invoicenumber !== newRow.sale_invoicenumber;
        if (invoiceChanged) {
          if (!newRow.sale_id) {
            newRow.temp_invoice_no = newRow.sale_invoicenumber || '';
          }
          else {
            newRow.temp_invoice_no = '';
          }
        }

        return newRow;
      }
      return row;
    });
    this.setState({ dataChanged: dirtyRows, data: updatedData });
  };

  handleChangeTab = (event, tabValue) => {
    this.setState({ tabValue: tabValue })
  }

  handleUploadDialogOpen = () => {
    this.setState({ uploadDialogOpen: true });
  };

  handleUploadDialogClose = () => {
    this.setState({ uploadDialogOpen: false });
  };

  handleSailingScheduleChange = async (property: string, value: any) => {
    this.setState({ sailingScheduleData: value });
  };//handle updates

  handleSailingScheduleFilterChange = (filters: FilterState) => {
    this.setState({ sailingScheduleFilters: filters });
  };

  handleSailingScheduleProcess = (visibleColumns: VisibleColumns) => {
    this.setState({
      sailingScheduleIsProcessed: true,
      sailingScheduleVisibleColumns: visibleColumns,
    });
  };

  handleSailingScheduleReset = () => {
    this.setState({
      sailingScheduleIsProcessed: false,
      sailingScheduleVisibleColumns: null,
      sailingScheduleFilters: {
        market: [],
        portOfLoading: [],
        portOfDischarge: [],
      },
    });
  };

  handleSailingScheduleRefresh = async () => {
    this.setState({ sailingScheduleLoading: true });
    try {
      const response = await getSailingScheduleData();
      this.setState({
        sailingScheduleData: response.data || [],
        sailingScheduleHeaders: response.headers || {},
        sailingScheduleLoading: false
      });
    } catch (error) {
      console.error('Error fetching sailing schedule:', error);
      this.setState({ sailingScheduleLoading: false });
    }
  };

  handleChangeSave = async () => {
    this.setState({ submitting: true });
    // console.log("SALE INVOICE NUMBER: ", this.state.data[2].sale_invoicenumber);
    // console.log("TEMP INVOICE NUMBER: ", this.state.data[2].temp_invoice_no);
    try {
      const updatedata = this.state.data.filter((ditem) => ditem.rowDirty == 1);
      const { sale, loadout, dispatch } = updatedata.reduce(
        ({ sale, loadout, dispatch }: any, row) => {
          if (row.sale_id) {
            sale.push({
              id: row.sale_id,
              date: row.sale_date ? row.sale_date : new Date(),
              ata: !row.sale_ata || row.sale_ata == "" ? null : row.sale_ata,
              arrived: row.sale_arrived ? row.sale_arrived : 0,
              collected: row.sale_collected ? row.sale_collected : 0,
              clientadvpd: row.sale_clientadvpd ? row.sale_clientadvpd : 0,
              freightpd: row.sale_freightpd ? row.sale_freightpd : 0,
              copydox: row.sale_copydox ? row.sale_copydox : 0,
              orgnldox: row.sale_orgnldox ? row.sale_orgnldox : 0,
              billtype: row.sale_billtype ? row.sale_billtype : "",
              clientfinpd: row.sale_clientfinpd ? row.sale_clientfinpd : 0,
              telex: row.sale_telex ? row.sale_telex : 0,
              accsalereceived: row.sale_accsalereceived ? row.sale_accsalereceived : 0,
              invoicenumber: row.sale_invoicenumber
            });
          }

          if (row.dispatch_id) {
            dispatch.push({
              id: row.dispatch_id,
              forwardagentref: row.forwardagentref,
            });
          }

          const { coldstoreoptions, portoptions, shippinglines, vesseloptions } = this.state;

          const coldroom_id = coldstoreoptions.find((citem) => citem.value == row.loadout_coldroomcode);
          const portLoading_id = portoptions.find((pitem: PortReadyForComboIdValue) => pitem.code == row.portloading_code);
          const portDischarge_id = portoptions.find((pitem: PortReadyForComboIdValue) => pitem.code == row.portdistcharge_code);
          const portFinal_id = portoptions.find((pitem: PortReadyForComboIdValue) => pitem.code == row.portfinal_code);
          const shipping_id = shippinglines.find((sitem) => sitem.code == row.shippingCode);
          const vessel_id = vesseloptions.find((vitem) => vitem.code == row.vessel_code);

          const loadoutData: any = {
            id: row.loadout_id,
            spec: row.loadout_spec == 1 ? 1 : 0,
            loadingdocs: row.loadout_loadingdocs == 1 ? 1 : 0,
            exportNotificationReference: row.loadout_exportNotificationReference,
            dateLoading: row.dateLoading,
            eta: row.loadout_eta,
            etd: row.loadout_etd,
            updated_eta: !row.loadout_updatedeta || row.loadout_updatedeta == "" ? null : row.loadout_updatedeta,
            voyageNumber: row.loadout_voyageNumber,
            collected: row.collected,
            notes: row.notes,
            logisticnotes: row.logisticnotes,
            consignee: row.clients_code,
            tempcode: row.tempcode,
            po: row.client_po,
            forwardagentref_temp: row.forwardagentref,
            vessel_id: row.vessel_code === "" || !vessel_id ? null : vessel_id.id,
            temp_invoice_no: row.temp_invoice_no
          };

          if (coldroom_id) loadoutData.coldroom_id = coldroom_id.id;
          if (portLoading_id) loadoutData.portLoading_id = portLoading_id.id;
          if (portDischarge_id) loadoutData.portDischarge_id = portDischarge_id.id;
          if (portFinal_id) loadoutData.portFinal_id = portFinal_id.id;
          if (shipping_id) loadoutData.shipping_id = shipping_id.id;

          loadout.push(loadoutData);
          return { sale, loadout, dispatch };
        },
        {
          sale: [],
          loadout: [],
          dispatch: [],
        },
      );

      // console.log("🚀 ~ StockAllocationTableUnstyled ~ data:", { sale, loadout, dispatch });
      await updateSaleJoinedRecord({ sale, loadout, dispatch });

      this.state.onReload();
    } catch (error) {
      const err = GenerateErrorMessage(error, "Error updating Shipment");
      this.context.updateSnack({ show: true, color: "red", message: err });
    }
    this.setState({ submitting: false });
  };

  rowRenderer = (props, classes) => {
    const { row } = props;
    const fontWeight = this.state.selectedLoadout.find((frow) => frow.loadout_reference == row.loadout_reference) && classes.boldRow;
    const fontColor = row.rowDirty == 1 ? classes.redRow : classes.blackRow;

    return <Row {...props} onDoubleClickCapture={() => this.handleAvailableLoadoutDoubleClick(row)} className={classNames(fontWeight, fontColor)} />;
  };

  selectedRowRenderer = (props, classes) => {
    const { row } = props;
    const color = row["producer_solasmethod2"] && (Number(row["weight"]) == 0 || Number(row["grossWeight"]) == 0) && classes.redRow;

    return <Row {...props} onDoubleClickCapture={() => this.handleSelectedStockDoubleClick(row)} className={color} />;
  };

  handleGridRefresh = () => {
    this.setState({ loading: true }, () => {
      this.state.onReload().then(() => {
        this.setState({ loading: false });
      });
    });
  };

  menuItems = {
    1: {
      title: "Shipments",
      action: (data, filters, columns) => {
        const formattedCols = columns.filter((col) => col.key !== "actions").map((col) => ({ key: col.key, header: col.name }));
        const formattedDate = data.map((row) => ({ ...row, barcode_palletsize: (row.barcode_palletsize || 0).toFixed(2) }));
        handleExportShipmentsData(formattedDate, formattedCols);
      },
    },
    2: {
      title: "Client Shipment Report",
      action: () => {
        this.setState({ clientDialog: true });
      },
    },
  };

  handlePrint = (is_loading: boolean) => {
    this.setState({ clientDialogLoading: is_loading });
  };

  handleCloseClientDialog = () => {
    this.setState({ clientDialog: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        {this.state.dialoginformation && (
          <DialogInformation
            isOpen={true}
            handleClose={this.handleInfoClose}
            handleOK={this.handleInfoClose}
            title={this.state.dialoginformation.title}
            body={`${this.state.dialoginformation.body}`}
            showinput={false}
          />
        )}
        {this.state.uploadDialogOpen && (
          <UploadDialog
            isOpen={this.state.uploadDialogOpen}
            handleClose={this.handleUploadDialogClose}
            onUploadSuccess={this.handleSailingScheduleRefresh}
          />
        )}
        {this.state.selectedRecord && (
          <Confirmation
            isOpen={true}
            handleClose={this.handleSelectedRecordClose}
            handleConfirm={this.handleSelectedRecordClose}
            title={`Selected Record (${this.state.selectedRecord.barcode}) Action`}
            body={undefined}
          >
            <LoadoutTableActionDialog row={this.state.selectedRecord} handleClose={this.handleSelectedRecordClose} />
          </Confirmation>
        )}
        {this.state.clientDialog && (
          <Confirmation
            isOpen={true}
            handleClose={this.handleCloseClientDialog}
            handleConfirm={this.handleCloseClientDialog}
            title={"Client Shipment Report - Select a client"}
            body={undefined}
            disableBackdropClick={this.state.clientDialogLoading}
          >
            <ClientSelector handlePrint={this.handlePrint} />
          </Confirmation>
        )}

        <AppBar position="static">
          <Tabs value={this.state.tabValue} onChange={this.handleChangeTab} aria-label="loadout-tabs">
            <Tab label="Shipments" {...a11yProps(0)} />
            <Tab label="Sailing Schedule" {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel className={classes.tabpanel} value={this.state.tabValue} index={0}>
          {!this.state.optionsLoaded ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <CircularProgress />
            </div>
          ) : (
            <div id="main_splitter_div" style={{ height: "100%", width: "100%", display: "grid" }}>
              <Splitter
                postPoned
                dispatchResize
                position="horizontal"
                primaryPaneWidth="100%"
                primaryPaneMaxHeight="calc(100% - 100px)"
                primaryPaneHeight="calc(100% - 350px)"
                onDragFinished={(e) => this.setGridHeights()}
              >
                <div id="primary_grid">
                  <Toolbar className={classes.toolbar}>
                    <div>
                      {this.state.dataChanged && (
                        <Button variant="contained" color="primary" onClick={() => this.handleChangeSave()} style={{ marginRight: "10px" }} disabled={this.state.submitting}>
                          save
                        </Button>
                      )}
                      {this.state.submitting && <CircularProgress color="secondary" size={25} />}
                    </div>
                  </Toolbar>
                  <LoadoutTableGridUnstyled
                    fill
                    gridHeight={this.state.minGridHeight}
                    loading={this.state.loading}
                    data={this.state.data}
                    rowRenderer={(props) => this.rowRenderer(props, classes)}
                    handleRefresh={this.handleGridRefresh}
                    clearFilters={"loadoutgrid"}
                    showFilterChips={true}
                    handleChange={this.handleChange}
                    menuItems={this.menuItems}
                    totalRowColumns={["barcode_nocartons", "barcode_palletsize"]}
                    countRowColumns={["loadout_reference"]}
                    handleAttachment={this.state.handleAttachment}
                    coldstoreoptions={this.state.coldstoreoptions}
                    portoptions={this.state.portoptions}
                    portoptionslocal={this.state.portoptionslocal}
                    shippinglines={this.state.shippinglines}
                    vesseloptions={this.state.vesseloptions}
                    billtypesData={this.state.billtypesData}
                    clientsoptions={this.state.clientsoptions}
                    groupedPortOptions={this.state.groupedPortOptions}
                    groupedClientOptions={this.state.groupedClientOptions}
                    tempcodes={this.state.tempcodes}
                  />
                </div>

                <div id="secondary_grid">
                  <LoadoutTableSelectedGridUnstlyed
                    data={this.state.selectedRows}
                    loading={this.state.loadingSelected}
                    gridHeight={this.state.minGridHeightSecond}
                    clearFilters={"loadoutselected"}
                    handleRefresh={() => {
                      this.setState({ loading: true }, () => {
                        this.state.onReload(true, true, true).then(() => {
                          this.setState({ loading: false });
                        });
                      });
                    }}
                    rowRenderer={(props) => this.selectedRowRenderer(props, classes)}
                    totalRowColumns={["noCartons", "palletSize", "grossWeight", "weight"]}
                  />
                </div>
              </Splitter>
            </div>
          )}
        </TabPanel>
        <TabPanel className={classes.tabpanel} value={this.state.tabValue} index={1}>
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: "10px", marginTop: "15px" }}
            onClick={this.handleUploadDialogOpen}
          >
            Upload Schedule
          </Button>
          <div style={{ height: "calc(100% - 70px)", marginTop: "10px" }}>
            <SailingScheduleGridUnstyled
              GridColumns={this.GridColumnsSailingSchedule}
              data={this.state.sailingScheduleData}
              portoptions={this.state.portoptions}
              vesseloptions={this.state.vesseloptions}
              shippinglines={this.state.shippinglines}
              loading={this.state.sailingScheduleLoading}
              clearFilters={"sailingschedule"}
              handleRefresh={this.handleSailingScheduleRefresh}
              menuItems={{}}
              headers={this.state.sailingScheduleHeaders}
              buttonFilters={this.state.sailingScheduleFilters}
              onFilterChange={this.handleSailingScheduleFilterChange}
              onProcess={this.handleSailingScheduleProcess}
              isProcessed={this.state.sailingScheduleIsProcessed}
              onReset={this.handleSailingScheduleReset}
              gridHeight={this.state.sailingScheduleGridHeight}
            />
          </div>
        </TabPanel>
      </div>
    );
  }
}

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`loadout-tabs-${index}`} aria-labelledby={`loadout-tabs-${index}`} {...other}>
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index) => {
  return {
    id: `loadout-tabs-${index}`,
    "aria-controls": `loadout-tabs-${index}`,
  };
};
export default withStyles(styles)(StockAllocationTableUnstyled);